export enum TAG {
  CLIENT_TYPE = 'ClientType',
  PRODUCT = 'Product',
  MODULE = 'Module',
  GENERIC_MODULE = 'GenericModule',
  GENERIC_MODULE_CONFIG = 'GenericModuleConfiguration',
  MODULE_HISTORY_VERSIONS = 'ModuleHistoryVersions',
  MODULE_VERSION_DATA = 'ModuleVersionData',
  GENERIC_MODULE_HISTORY_VERSIONS = 'GenericModuleHistoryVersions',
  GENERIC_MODULE_VERSION_DATA = 'GenericModuleVersionData',
}
